if (!customElements.get('pack-quantity-selector')) {
  customElements.define(
    'pack-quantity-selector',
    class PackQuantitySelector extends HTMLElement {
      constructor() {
        super();
        this.rows = Array.from(this.querySelectorAll('.pack-quantity-selector__row'));
        this.totalInput = this.querySelector('[data-pack-total-quantity]');
        this.addEventListener('change', this.onChange.bind(this));
      }

      connectedCallback() {
        this.updateTotal();
      }

      get submitButton() {
        const form = document.getElementById(this.dataset.formId);
        return form ? form.querySelector('[type="submit"]') : null;
      }

      onChange(event) {
        if (!event.target.matches('.quantity__input')) return;
        this.updateTotal();
      }

      updateTotal() {
        const total = this.rows.reduce((sum, row) => {
          const multiplier = parseInt(row.dataset.packMultiplier, 10) || 0;
          const quantity = parseInt(row.querySelector('.quantity__input').value, 10) || 0;
          return sum + multiplier * quantity;
        }, 0);

        if (this.totalInput) this.totalInput.value = total;

        const submitButton = this.submitButton;
        if (submitButton) submitButton.toggleAttribute('disabled', total === 0);
      }
    }
  );
}
